<template>
  <div class="tab-pane fade show active" id="nav-5-3-primary-ver--1" role="tabpanel">
        <span v-on:click="toggleCollapse(collapseStatus)" class="pull-right" style=""><a class="g-font-size-12" v-if="collapseStatus == false">Expand All </a><a class="g-font-size-12" v-if="collapseStatus == true">Collapse All</a></span>
        <!-- Accordion -->
        <h3 class="g-color-main">General</h3>
        <div style="background-color: #26304d; height: 3px; margin-bottom: 10px"></div>
        <div v-for="(group, index) in groups" id="accordion-12-1" class="u-accordion u-accordion-color-primary" role="tablist" aria-multiselectable="true">
            <!-- Card -->
            <div class="card g-brd-none rounded-0" :class="{'g-bg-secondary': ((index % 2) == 1)}">
            <div id="accordion-12-1-heading-01" class="u-accordion__header g-color-text g-font-weight-500" role="tab">
                <h5 class="g-font-size-20 mb-0">
                <a v-on:click="changeCollapse(group)" class="d-block g-color-text g-color-primary--hover g-font-size-20--md g-font-size-17 g-text-underline--none--hover g-pa-12"  data-toggle="collapse" data-parent="#accordion-12-1" aria-expanded="true" aria-controls="accordion-12-1-body-01">
                    {{group.name}}
                </a>
                </h5>
            </div>
            <div v-show="group.open" id="accordion-12-1-body-01" class="collapsed show" role="tabpanel" aria-labelledby="accordion-12-1-heading-01">
                <div class="u-accordion__body g-color-text g-pa-30 g-pt-0">
                <span class="g-font-size-20--md g-font-size-17" v-html="group.items"></span>
                </div>
            </div>
            </div>
            <!-- End Card -->
        </div>
        <!-- End Accordion -->
    </div>
</template>
<script>
export default {
    data () {
    return {
        collapseStatus: false,
        groups: [
            {
                "name": "How does this program help the eye doctor or charity?",
                "open": false,
                "items": "Changing Life through Lenses&reg; is intended to support eye doctors and non-profits providing philanthropic vision services. The site offers real-time ordering of glasses and lenses, referral tracking and educational resources on how to engage in your community."
            },
            {
                "name": "What kind of product selection will I have?",
                "open": false,
                "items": "Essilor Vision Foundation offers Polycarbonate Single Vision and Bifocal lenses and frames provided by FGX International. Should medically necessary products be required, the doctor may indicate the Special Request in the order for review and consideration."
            },
            {
                "name": "What costs are associated for each order?",
                "open": false,
                "items": "There is no charge for the hardware or the manufacturing of the glasses. The only costs to the eye doctor or charity will be the shipping of the frame for any frame-to-come orders, to the designated laboratory."
            },
            {
                "name": "What are the requirements for a free pair of glasses?",
                "open": false,
                "items": "This program is for patients who are at or below the poverty level and do not have insurance for vision services and hardware, as reasonably determined by the provider. It is expected that the eye doctor and his or her staff would donate the time for the exam; however, if not, dollars can only be reimbursed by the patient for the eye exam or any hardware NOT provided by EVF."
            },
            {
                "name": "What costs are associated for each order?",
                "open": false,
                "items": "There is no charge for the glasses provided by EVF. The only costs to the eye doctor or charity would be for Frame-to-Come orders 1) the cost of the frame and 2) the shipping of the frame to the designated laboratory."
            },
            {
                "name": "Can I register for more than one account?",
                "open": false,
                "items": "You can register for more than one account type (Individual, Business, Non-Profit); however, you may only register for one account per type. Additionally, each account will require a different email address for login. For instance you can register as an<b> Individual</b> for any charity work you may do on your own and you may register as a <b>Practice/Business</b> for that work which may be done within your practice or practice locations."
            },
            {
                "name": "How will a lab be selected?",
                "open": false,
                "items": "Essilor Vision Foundation will determine the lab at the time the order is placed online. The website is designed to select the most efficient manner for production based on the Essilor lab network."
            },
            {
                "name": "Can the same lab account be used for private pay and charity work?",
                "open": false,
                "items": "Unfortunately not. Charitable lab work will not be processed through an existing private pay or managed care lab account. Accounts cannot be linked for the purposes of ordering charity jobs."
            }
        ]
    }
    },
    methods: {
        toggleCollapse(collapseStatus) {
            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(element => {
                element.open = this.collapseStatus;
            });
        },
        changeCollapse(group) {
            this.groups.forEach(element => {
                element.open = false;
            });
            group.open = true;
        }
    }
}
</script>



// WEBPACK FOOTER //
// General.vue?dfa2acd8